import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "@/i18n";
import * as serviceWorker from "@/serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { Buffer } from "buffer";
import { ThirdwebProvider } from "thirdweb/react";

import store from "./store";

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <ThirdwebProvider>
        <App />
      </ThirdwebProvider>
    </BrowserRouter>
  </Provider>
);

window.Buffer = window.Buffer || Buffer;
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(app);

serviceWorker.unregister();
